import AjaxUtil from '../../axios/axios';

export const getJournals = async(page, reqObj) => {
    try {
        return await AjaxUtil.sendRequest(`findjournal/${page}/10`, reqObj, false, { method: 'post', showError: true, isProfile: true} );
    } catch (error) {
        throw error;
    }
}
